import { PaginatedResponse } from '../interfaces/PaginatedResponse';
import Resource from '../Resource';

export class ServiceAlert extends Resource {

  protected override endpoint = '/api/v1/servicealerts';

  public title: string = '';
  public message: string = '';
  public activeFrom: string = '';
  public durationInHours: number = 0;
  public createdBy: string = '';
  public isActive: boolean = false;

  public createdDate: string = '';

  public async listActive(): Promise<ServiceAlert[]> {
    const response = await this.withTempEndpoint(`${this.endpoint}/active`, () =>
      this.get<ServiceAlert[] | PaginatedResponse<ServiceAlert>>()
    );

    return Array.isArray(response) ? response : response?.data ?? [];
  }
}
